import { useMemo } from 'react';
import { getQuarterCurrent } from '@app/utils/quarters';
import { HashrateDynamics } from 'features/managers-perfomance/hashrate-dynamics/hashrate-dynamics';
import {
  ProgressCard,
  StatCard,
  QuarterlyBonusTable,
  YearlyBonusTable,
} from 'features/managers-perfomance/personal-result';

type Props = {
  managerId: number | null;
  canEditPlans: boolean;
};

export const PersonalResult = ({ managerId, canEditPlans }: Props) => {
  const currentYear = new Date().getFullYear();

  const currentQuarter = useMemo(() => getQuarterCurrent(), []);

  const progressCards = [
    { type: 'monthly' as const },
    { type: 'quarterly' as const },
    { type: 'yearly' as const },
  ];

  return (
    <>
      <div className="grid grid-cols-4 gap-5 mb-5">
        <div className="col-span-3 grid grid-cols-3 gap-5 items-start">
          {progressCards.map(card => (
            <ProgressCard
              key={card.type}
              type={card.type}
              managerId={managerId}
              year={currentYear}
              quarter={currentQuarter}
              canEditPlans={canEditPlans}
            />
          ))}
        </div>
        <div className="grid grid-cols-1 gap-5 items-start">
          <StatCard type="clientsHashrate" managerId={managerId} />
          <StatCard type="clientsCount" managerId={managerId} />
        </div>
      </div>
      <HashrateDynamics managerId={managerId} />
      <QuarterlyBonusTable year={currentYear} quarter={currentQuarter} />
      <YearlyBonusTable year={currentYear} canEdit={canEditPlans} />
    </>
  );
};
